/**
 * event_markers.ts — LIVE EVENTS ON THE MAPS (client sweep 2026-10-05, G5). PURE.
 *
 * Festivals, feasts and rites had a stage, a toast and a planner window, but neither map showed where one was live. A marker
 * is a `living_event` row of THIS world that is live and not over (battles keep their own layer), with its kind's glyph and
 * its title for the label; clicking one sets a waypoint on it (lib/event_waypoint.ts).
 */
export interface EventRowLike {
  eventId: bigint; worldId: bigint; kind: string; family: string; x: number; z: number; title: string; phase: string;
  endsAt: { microsSinceUnixEpoch: bigint };
}
export interface KindInfo { label: string; glyph: string }
export interface EventMarker { id: string; x: number; z: number; title: string; glyph: string; label: string; minutesLeft: number }

export function liveEventMarkers(rows: Iterable<EventRowLike>, worldId: bigint | null, nowMs: number, kinds: Readonly<Record<string, KindInfo>>): EventMarker[] {
  const out: EventMarker[] = [];
  if (worldId === null) return out;
  const nowUs = BigInt(Math.floor(nowMs)) * 1000n;
  for (const e of rows) {
    if (e.worldId !== worldId || e.phase !== 'live' || e.family === 'battle') continue;
    if (e.endsAt.microsSinceUnixEpoch <= nowUs) continue;
    if (!Number.isFinite(e.x) || !Number.isFinite(e.z)) continue;
    const k = kinds[e.kind];
    if (!k) continue;
    out.push({ id: e.eventId.toString(), x: e.x, z: e.z, title: e.title, glyph: k.glyph, label: k.label,
      minutesLeft: Math.max(1, Math.round(Number(e.endsAt.microsSinceUnixEpoch - nowUs) / 1e6 / 60)) });
  }
  return out;
}

/** The marker within `radius` px of (px, py), nearest first (the maps' own hit-test shape). */
export function eventMarkerAt(markers: readonly EventMarker[], toX: (x: number) => number, toY: (z: number) => number, px: number, py: number, radius = 12): EventMarker | null {
  let best: EventMarker | null = null, bd = radius;
  for (const m of markers) {
    const d = Math.hypot(toX(m.x) - px, toY(m.z) - py);
    if (d <= bd) { bd = d; best = m; }
  }
  return best;
}
